module.exports = __webpack_public_path__ + "static/img/index_banner.8bad887.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index_banner.png
// module id = qgmf
// module chunks = 4